export default __webpack_public_path__ + "static/dan@2x-79c106b8d04c27d0804ccaf46a237a89.png";